import disposeFarAway from './farAway'
import disposeshopkeeper from './shopkeeper'
import disposeMall from './mall'
import disposeCollocate from './collocate'

const dispose = {
  path: 'dispose/:merchantId',
  component: resolve => require(['../../../../../pages/admin/merchant/dispose'], resolve),
  redirect: 'dispose/:merchantId/faraway',
  children: [
    disposeFarAway,
    disposeshopkeeper,
    disposeMall,
    disposeCollocate
  ],
  meta: {
    requireAuth: true
  }
}

export default dispose